import { render, staticRenderFns } from "./WorkingProcedure.vue?vue&type=template&id=3625ca5f&scoped=true"
import script from "./WorkingProcedure.vue?vue&type=script&lang=tsx"
export * from "./WorkingProcedure.vue?vue&type=script&lang=tsx"
import style0 from "./WorkingProcedure.vue?vue&type=style&index=0&id=3625ca5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625ca5f",
  null
  
)

export default component.exports